module.exports = __webpack_public_path__ + "static/media/ic_calendar.4197ac73.webp";